<template>
  <font-awesome-icon
    data-pendo-gc="icon"
    :icon="icon"
    :spin="spin"
    :style="{
      fontSize: fontSize,
      color: color,
      '--fa-primary-opacity': primaryOpacity,
      '--fa-secondary-opacity': secondaryOpacity,
    }"
  />
</template>

<script lang="ts">
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'BaseIcon',
    components: {
      FontAwesomeIcon,
    },
    props: {
      icon: {
        type: String,
        required: true,
      },
      fontSize: {
        type: String,
        default: 'inherit',
      },
      color: {
        type: String,
        default: 'inherit',
      },
      spin: {
        type: Boolean,
        default: false,
      },
      primaryOpacity: {
        type: Number,
        default: 1.0,
      },
      secondaryOpacity: {
        type: Number,
        default: 0.4,
      },
    },
  }
</script>
